import React from 'react'

import classes from './style.module.css'

const Balance: React.FC = () => {
  return (
    <div className={classes.container}>
      <div className={classes.balance}>
        <h2>Баланс</h2>

        <div style={{ fontSize: '1.2rem' }}>
          <a href={`${process.env.REACT_APP_OTK_ID_PROFILE_URL}balance`} target="_blank" rel="noreferrer noopener">
            Баланс и платежи
          </a>{' '}
          теперь в личном кабинете.
        </div>
      </div>
    </div>
  )
}

export default Balance
